import { render, staticRenderFns } from "./Shebei.vue?vue&type=template&id=ebdd15dc&scoped=true&"
import script from "./Shebei.vue?vue&type=script&lang=ts&"
export * from "./Shebei.vue?vue&type=script&lang=ts&"
import style0 from "./Shebei.vue?vue&type=style&index=0&id=ebdd15dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdd15dc",
  null
  
)

export default component.exports